import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { WorkflowSettingsScreen } from '@/features/workflow-settings/settings-screen'
import { useEffectiveGrants } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/settings/workflows')({
  component: WorkflowsRoute,
})

export function WorkflowsRoute() {
  const { can } = useEffectiveGrants()
  const navigate = useNavigate()
  if (!can('workflow.view')) {
    void navigate({ to: '/' })
    return null
  }
  return <WorkflowSettingsScreen />
}
